import * as React from "react";
import Modal from "../Shared/Modal";
import i18n from "../i18n";
import "./BankeiLiftTicketModal.scss";

interface IProps {
  isShown: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const BankeiLiftTicketModal: React.FC<IProps> = ({
  isShown,
  onClose,
  onConfirm,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal isShown={isShown} handleClose={onClose} className="bankei-lift-ticket-modal">
      <div className="bankei-lift-ticket-modal-body">
        <h3 className="bankei-lift-ticket-modal-title">
          {i18n.t("snow_items.bankei_lift_ticket_modal.title")}
        </h3>
        <div className="bankei-lift-ticket-modal-notice-card">
          <ul className="bankei-lift-ticket-modal-notice-list">
            <li>
              {i18n.t("snow_items.bankei_lift_ticket_modal.no_round_trip")}
            </li>
            <li>
              {i18n.t(
                "snow_items.bankei_lift_ticket_modal.no_sightseeing_ride",
              )}
            </li>
            <li>
              {i18n.t(
                "snow_items.bankei_lift_ticket_modal.equipment_required",
              )}
            </li>
          </ul>
        </div>
      </div>
      <div className="bankei-lift-ticket-modal-footer">
        <button
          type="button"
          onClick={handleConfirm}
          className="snow-cart-button w-100 btn btn-primary bankei-lift-ticket-modal-confirm-button"
        >
          {i18n.t("snow_items.bankei_lift_ticket_modal.add_to_cart")}
        </button>
        <button
          type="button"
          onClick={onClose}
          className="btn btn-light w-100 bankei-lift-ticket-modal-back-button"
        >
          {i18n.t("base.back")}
        </button>
      </div>
    </Modal>
  );
};

export default BankeiLiftTicketModal;
